export const CREATE_HOSPITAL_BREADCRUMBS = (
  id?: string,
  hsName?: string,
  hsId?: string,
  name?: string
) => [
  {
    children: 'My community',
    href: '/my-community'
  },
  {
    children: 'My organization',
    href: '/my-community/my_organization/'
  },
  {
    children: 'Health Systems',
    href: '/my-community/my_organization/health_systems/'
  },
  {
    children: hsName,
    href: '/my-community/my_organization/health_systems/' + hsId
  },
  {
    children: id === 'new' ? 'Hospital creation' : name ?? ''
  }
]

export const CREATE_EDIT_HOSPITAL_TABS = [
  {
    key: 'general',
    label: 'Hospital Details'
  },
  {
    key: 'users',
    label: 'Users'
  },
  {
    key: 'banking_setup',
    label: 'Banking setup'
  },
  {
    key: 'bank_accounts',
    label: 'Bank accounts'
  }
]
export const VIEW_HOSPITAL_TABS = [
  {
    key: 'general',
    label: 'Hospital Details'
  }
]
